import React, { Component } from 'react';
import { translate } from 'react-i18next';

class BalanceDialog extends Component {
  render() {
    const { t } = this.props;
    const balance = this.props.balance;

    return (
      <div>
        <button
          className="hidden"
          data-target="#modalBalance"
          data-toggle="modal"
          id="btnBalance"
          type="button">
        </button>
        <div className="modal fade" id="modalBalance" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button className="close" data-dismiss="modal" type="button">&times;</button>
                <h4 className="modal-title">{t('dashboard.profile.balance_title')}</h4>
              </div>
              <div className="modal-body">
                <form>
                  <fieldset>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="total">
                            {t('dashboard.profile.label_total_hours')}
                          </label>
                          <input
                            className="form-control"
                            id="total"
                            readOnly
                            type="text"
                            value={balance.total_hours} />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="remaining">
                            {t('dashboard.profile.label_remaining_hours')}
                          </label>
                          <input
                            className="form-control"
                            id="remaining"
                            readOnly
                            type="text"
                            value={balance.remaining_hours} />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="included">
                            {t('dashboard.profile.label_included')}
                          </label>
                          <input
                            className="form-control"
                            id="included"
                            readOnly
                            type="text"
                            value={balance.included} />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="not_included">
                            {t('dashboard.profile.label_not_included')}
                          </label>
                          <input
                            className="form-control"
                            id="not_included"
                            readOnly
                            type="text"
                            value={balance.not_included} />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-default"
                  data-dismiss="modal"
                  type="button">
                  {t('dashboard.profile.btn_close_balance')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(BalanceDialog);



// WEBPACK FOOTER //
// ./src/dashboard/profile/BalanceDialog.js